import styled, { keyframes } from 'styled-components/macro';
import { device } from 'components/styles/MediaQuery';
import { hexToRGB } from '@repo-level/core-front';

import bg from 'assets/images/EasterWonderland/easterWonderlandBg.jpg';
import bgMob from 'assets/images/EasterWonderland/easterWonderlandBgMob.jpg';

const bounce = keyframes`
  0%{
    transform: translateY(0);
  }
  100%{
    transform: translateY(-5%);
  }
`;

export const ScMysticCarnival = styled.div`
  position: relative;
  max-width: 640px;
  min-height: 372px;
  background: url(${bg}) center / cover no-repeat;
  border-radius: 16px;
  margin: 32px auto;
  padding: 32px 30px;
  @media (${device.mobileXS}) {
    background: url(${bgMob}) center / cover no-repeat;
    padding: 24px 16px;
    margin-inline: 8px;
    min-height: 624px;
  }

  & > .coin {
    display: block;
    position: absolute;
    top: 80px;
    left: -56px;
    width: 80px;
    height: 57px;
    animation: ${bounce} 2.7s 0.1s ease alternate infinite;
    @media (${device.mobile}) {
      left: 16px;
      top: -32px;
    }
  }

  & > .flying-frame {
    display: block;
    position: absolute;
    bottom: 12px;
    right: -56px;
    width: 146px;
    height: 146px;
    animation: ${bounce} 2s 0.1s ease alternate infinite;
    @media (${device.mobile}) {
      bottom: -32px;
      right: 8px;
      width: 164px;
      height: 164px;
    }
  }

  & > .content {
    max-width: 324px;
    text-align: center;
    &.de {
      max-width: 341px;
    }
    @media (${device.mobileXS}) {
      max-width: none;
      &.de {
        max-width: none;
      }
    }

    h3 {
      font-weight: 700;
      font-size: 22px;
      line-height: 28px;
      letter-spacing: 0.01em;
      margin-bottom: 32px;
      color: #ffcf24;
      @media (${device.mobileXS}) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 24px;
      }
    }

    .details {
      & > h2 {
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0.01em;
        margin-bottom: 32px;
        @media (${device.mobileXS}) {
          font-size: 18px;
          line-height: 24px;
          margin-bottom: 24px;
        }
      }

      &__offer {
        font-weight: 700;
        font-size: 36px;
        line-height: 44px;
        margin-bottom: 8px;
        letter-spacing: 0.03em;
        @media (${device.mobileXS}) {
          max-width: 300px;
          margin-inline: auto;
          font-size: 32px;
          line-height: 38px;
          margin-bottom: 6px;
        }
      }

      &__terms {
        display: flex;
        justify-content: space-between;
        margin-inline: auto;
        column-gap: 10px;
        margin-bottom: 24px;
        @media (${device.mobileXS}) {
          justify-content: center;
          column-gap: 14px;
        }

        .item {
          display: flex;
          align-items: center;
          column-gap: 8px;

          .value {
            font-size: 12px;
            line-height: 18px;
            color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.8)};
            @media (max-width: 367px) {
              font-size: 9px;
            }
          }
          .icon svg {
            display: block;

            path {
              fill: ${({ theme }) => hexToRGB(theme.whiteColor, 0.8)};
            }
          }
        }
      }

      & > button {
        width: 240px;
        height: 40px;
        @media (${device.mobileXS}) {
          width: 100%;
        }
      }
    }
    @media (max-width: 390px) {
      &.de .item .value {
        font-size: 9px;
      }
    }
    @media (max-width: 385px) {
      &.fr > h3 {
        max-width: 275px;
        margin-inline: auto;
      }
    }
  }
`;
